import { render, staticRenderFns } from "./custom-promised-alert-component.vue?vue&type=template&id=4826c334"
import script from "./custom-promised-alert-component.vue?vue&type=script&lang=js"
export * from "./custom-promised-alert-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4826c334')) {
      api.createRecord('4826c334', component.options)
    } else {
      api.reload('4826c334', component.options)
    }
    module.hot.accept("./custom-promised-alert-component.vue?vue&type=template&id=4826c334", function () {
      api.rerender('4826c334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-promised-alert-component.vue"
export default component.exports